const getLabelForOrderMethodStatus = status => {
  switch (status) {
    case "COMPLETE":
      return "Complete";
    case "IN_PROGRESS":
      return "In Progress";
    case "NOT_APPLICABLE":
      return "Not Applicable";
    case "ON_HOLD":
      return "On Hold";
    case "READY":
      return "Ready";
    case "LOCATED":
      return "Located";
    case "QUEUED":
      return "Queued";
    case "STAGED":
      return "Staged";
    case "TRIMMED":
      return "Trimmed";
    case "PAUSED":
      return "Paused";
    default:
      return status;
  }
};

export { getLabelForOrderMethodStatus };
